import { ToggleButton, ToggleButtonGroup } from 'component-library';
import { useTranslation } from 'react-i18next';

import {
  PLOT_OVERVIEW_SHAPE,
  PlotOverviewShape,
  useControlsContext,
} from '@/components/widgets/o/Map/hooks/useFormControls';

import { SectionTitle, SectionWrapper } from './Sections';

export const PlotOverviewToggle = () => {
  const { t } = useTranslation();
  const controlsForm = useControlsContext();
  const plotOverviewShape = controlsForm.watch('plotOverviewShape');

  const handleOnChange = (value: PlotOverviewShape) => {
    controlsForm.setValue('plotOverviewShape', value);
  };

  return (
    <SectionWrapper>
      <SectionTitle text={t('shared.projects.project.mapLayerEditMenu.plotOverview.labels.shape')} />
      <ToggleButtonGroup value={plotOverviewShape} onChange={handleOnChange} size='small' className='grid grid-cols-2'>
        <ToggleButton value={PLOT_OVERVIEW_SHAPE.polygon}>
          {t('shared.projects.project.mapLayerEditMenu.plotOverview.labels.polygon')}
        </ToggleButton>
        <ToggleButton value={PLOT_OVERVIEW_SHAPE.border}>
          {t('shared.projects.project.mapLayerEditMenu.plotOverview.labels.border')}
        </ToggleButton>
      </ToggleButtonGroup>
    </SectionWrapper>
  );
};
